import { isPossibleDestination } from "./StationMapper";
import { DynamicSettings } from "Components/admin/DynamicSettings";
import { OUTBOUND } from "Services/constants";
import { Country, City, RoutePickerModel } from "../RoutePickerModel";

export const ALL_COUNTRY_CODE = "all";

export type MacDictionary = Map<string, Set<string>>;

export const stationUtils = () => {
	const getPossibleDestinations = (countries: Country[], origin: City): Country[] => {
		if (!origin) return countries;

		return countries
			.map((country) => getCountryWithPossibleDestinations(country, origin))
			.filter((country) => country.cities.length > 0);
	};

	const getCountryWithPossibleDestinations = (country: Country, origin: City): Country => ({
		...country,
		cities: country.cities.filter((city) => isPossibleDestination(origin, city)),
	});

	const doesCityBeginWithSubstring = (city: City, searchExpression: string) =>
		city.code.toLowerCase().indexOf(searchExpression.toLowerCase()) === 0 ||
		getDisplayedCityName(city).toLowerCase().indexOf(searchExpression.toLowerCase()) === 0;

	// EXPORTS
	const getDefaultCountryCodeFromSettings = (
		journeyIndex: number,
		culture: string,
		dynamicSettings: DynamicSettings
	) => {
		const defaultCountries = dynamicSettings.DefaultRouteCountrySettings?.find(
			(setting) => setting.Culture.toLowerCase() === culture.toLowerCase()
		);

		return (
			(journeyIndex === OUTBOUND
				? defaultCountries?.DefaultOriginCountryCode
				: defaultCountries?.DefaultDestinationCountryCode) || culture.substring(3, 5)
		);
	};

	const getDisplayedCityName = (city: City) => `${city.name} (${city.code})`;

	const getFilteredModel = (model: Country[], searchExpression: string): Country[] =>
		searchExpression
			? model
					.map((country) => ({
						...country,
						cities: country.cities.filter((city) => doesCityBeginWithSubstring(city, searchExpression)),
					}))
					.filter((country) => country.cities.length)
			: model;

	const getRouteModel = (countries: Country[], selectedOrigin?: City): RoutePickerModel => {
		if (!countries) throw new Error("Station handler was not initialized.");

		if (selectedOrigin) return { countries: getPossibleDestinations(countries, selectedOrigin) };

		return { countries };
	};

	return {
		getDefaultCountryCodeFromSettings,
		getFilteredModel,
		getRouteModel,
		isPossibleDestination,
	};
};
